import { Component, OnInit, HostListener } from '@angular/core';
import { CheckboxesService } from '../../services/checkboxes.service'

/**
 * Component que s'encarrega de mostrar a l'usuari les opcions disponibles per carregar capes de marcadors d'incidències
 */
@Component({
  selector: 'app-alertes',
  templateUrl: './alertes.component.html',
  styleUrls: ['./alertes.component.css']
})
export class AlertesComponent implements OnInit {

  /**
   * @ignore
   */
  @HostListener('window:resize')
  onResize() {
    this.setScreenMode();
  }

  /**
   * Valor constant que indica la posició del tipus d'alerta `CONGESTION` a l'array `alertes`
   */
  CONGESTION = 0;

  /**
   * Valor constant que indica la posició del tipus d'alerta `CONES` a l'array `alertes`
   */
  CONES = 1;

  /**
   * Valor constant que indica la posició del tipus d'alerta `ROADWORKS` a l'array `alertes`
   */
  ROADWORKS = 2;

  /**
   * Valor constant que indica la posició del tipus d'alerta `INCIDENT` a l'array `alertes`
   */
  INCIDENT = 3;

  /**
   * Valor constant que indica la posició del tipus d'alerta `METEO` a l'array `alertes`
   */
  METEO = 4;

  /**
   * Valor constant que indica la posició del tipus d'alerta `CAMERA` a l'array `alertes`
   */
  CAMERA = 5;

  /**
   * Valor constant que indica la posició del tipus d'alerta `MOUNTAINPASS` a l'array `alertes`
   */
  MOUNTAINPASS = 6;

  /**
   * Tots els tipus d'incidències disonibles
   */
  alertes: string[] = ['CONGESTION','CONES','ROADWORKS','INCIDENT','METEO','CAMERA','MOUNTAINPASS'];

  /**
   * Tenint en compte les constants de posició pels diferents tipus d'incidències, indica si estan activats o no els seus respectius checkboxes
   */
  checkboxes: boolean[] = [false,false,false,false,false,false];

  /**
   * Indica el mode de pantalla en que està l'aplicació (escriptori, mòbil vertical o mòbil horitzontal
   */
  screenMode: string = ''; 


  /**
   * Canvia la propietat `screenMode` d'acord amb la mida de la pantalla de l'usuari
   */
  setScreenMode(): void{
    if(window.screen.width < 568)
      this.screenMode = 'portrait';
    else if(window.screen.width < 824)
      this.screenMode = 'landscape';
    else 
      this.screenMode = 'desktop';
  }
  
  /**
   * Activa o desactiva una de les capes de marcadors d'incidències
   * @param {string} layer Nom de la capa de marcadors que volem activar o desactivar
   */
  toggleCheckbox(layer: string): void{
    if(this.checkboxes[this.alertes.indexOf(layer)]) this.checkboxesService.deleteCheckbox(layer);
    else this.checkboxesService.addCheckbox(layer);
  }

  /**
   * Constructor del component
   * @param checkboxesService {CheckboxesService} Servei que conté els noms de les capes de marcadors activades
   */
  constructor(private checkboxesService: CheckboxesService) { }

  /**
   * Inicialitza el component configurant la pàgina segons la mida de la pantalla. Es subscriu al sevei checkboxesService
   */
  ngOnInit() {

    this.setScreenMode();
    
    this.checkboxesService.getCheckboxes().subscribe(data => {
      for(var i = 0; i < 7; i++){
        if(data.includes(this.alertes[i])) this.checkboxes[i] = true;
        else this.checkboxes[i] = false;
      }
    });

    

  }

}
